<script>
    // @ts-nocheck
    import Breadcrumb from '$lib/components/UI/Breadcrumb.svelte'
    import Banner from '$lib/components/UI/Banner.svelte'
    import {
        Form,
        Alert,
        Button,
        Typography,
        Avatar,
        FormBoxContainer,
        FormBoxRow,
        FormBoxCell,
        InputText,
        InputPassword,
        Modal,
        BackDrop,
    } from '$lib/components/UI'
    import { LockClosedOutline } from '$lib/components/Icons'
    import { fly } from 'svelte/transition'
    import { navigate } from 'svelte-navigator'
    import { getContext } from 'svelte'
    import user from '$lib/stores/user'
    import provider from '$lib/stores/provider'
    import { API_URL, configImpuestos } from '$lib/conf'
    import { resolveFormfields } from '$lib/utils'
    import Spinner from '$lib/components/UI/Spinner.svelte'
    import ModificacionProveedor from '$lib/custom/components/ModificacionProveedor.svelte'
    import WidgetModificacion from '$lib/custom/components/WidgetModificacion.svelte'
    import ViewModificacion from '$lib/custom/components/ViewModificacion.svelte'
    import ProviderDetail from '$lib/custom/components/ProviderDetail.svelte'
    import Edit from '$lib/components/Icons/custom/Edit.svelte'
    import Tick from '$lib/components/Icons/custom/Tick.svelte'
    let sites = [
        { label: 'Atrás', path: -1 },
        { label: 'Perfil de usuario', path: '/home/profile' },
        { label: 'Gestion', path: '/home/profile/admin' },
    ]
    let dataForm = {}
    let certificados = []
    let confCert = {}
    let itemDocs = {}
    let dataFetch = {}
    const toast = getContext('toast')

    function getData() {
        return user.fetch(`${API_URL}/provider/${user.currentAccount}`, {
            method: 'GET',
        })
            .then(async (r) => {
                if (r.ok) {
                    let ret = await r.json()
                    try {
                        provider.update(ret)
                    } catch (e) {
                        console.error(e)
                    }
                    let { data, documentation, editable, modificationRequest } =
                        ret
                    certificados = documentation.map(([name]) => {
                        return name
                    })
                    itemDocs = documentation.map((x) => x[1])
                    itemDocs = {
                        active: itemDocs.filter((x) =>
                            [true, 'true'].includes(x.activa)
                        ),
                        pending: itemDocs.filter(
                            (x) => ![true, 'true'].includes(x.activa)
                        ),
                    }
                    editableForm = editable
                    dataFetch = structuredClone(data)
                    dataModification = modificationRequest
                    return editable ? ret : { ...ret, data: ret.tmpData }
                } else {
                    return null
                }
            })
            .catch((_) => null)
    }
    let request = getData()
    let editableForm = true
    let lockButton = false
    let confirmaMigrado = false
    let confirmationCompleted =
        window.localStorage.getItem('dataConfirmation') === null

    function sendData(data) {
        lockButton = true
        fetching = true
        user.fetch(`${API_URL}/provider/${$user?.defaultAccount}`, {
            method: 'PUT',
            body: JSON.stringify(data),
        })
            .then(async (r) => {
                if (r.ok) {
                    let ret = await r.json()
                    provider.update(ret)
                    request = getData()
                    lockButton = false
                    if (!confirmationCompleted) {
                        confirmaMigrado = false
                        confirmationCompleted = true
                        addHistoryLog(
                            `${$user.name} ${$user.lastName} - Rechazo los datos del proveedor migrado y solicito modificaciones.`
                        )
                    }
                    try {
                        window.localStorage.removeItem('dataConfirmation')
                    } catch (e) {}
                    showEditMod = false
                    return ret
                } else {
                    return null
                }
            })
            .catch((_) => null)
            .finally((_) => {
                fetching = false
                showEditMod = false
            })
    }
    function addHistoryLog(log, callback = (_) => _) {
        callback()
        return user.fetch(`${API_URL}/services/history`, {
            method: 'POST',
            body: JSON.stringify({
                id: user.currentAccount || '',
                log,
            }),
        })
        .then(async (r) => {
            if (r.ok) {
                return r
            } else {
                throw new Error(
                    `Error al registrar evento "${r.statusText} (${r.status})"`
                )
            }
        })
        .catch((r) => r)
    }
    function filterCert(conf) {
        let ret = {}
        Object.keys(conf).forEach((impuesto) => {
            ret[impuesto] = Object.entries(conf[impuesto])
                .map((o) => o[1])
                .filter((opt) => {
                    return !certificados.includes(opt.namePrimary)
                })
        })
        return ret
    }
    let diffData
    $: if (dataForm || dataFetch) {
        let a = Object.entries(structuredClone(dataFetch)).reduce(
            (acc, [k, v]) => ({ ...acc, [k]: JSON.stringify(v) }),
            {}
        )
        let b = Object.entries(structuredClone(dataForm)).reduce(
            (acc, [k, v]) => ({ ...acc, [k]: JSON.stringify(v) }),
            {}
        )
        let ks = Object.keys(a).filter((k) => k in b)
        diffData = ks.filter((k) => a[k] !== b[k]).map((k) => [k, a[k], b[k]])
    }
    $: if (certificados) confCert = filterCert(configImpuestos)
    let ref = {
        condicion_imp_ganancias_ii: 'condicion_ganancias',
        condicion_imp_ingresos_ii: 'condicion_iibb',
        condicion_imp_iva_ii: 'condicion_iva',
    }
    $: docNeeded = Object.entries(ref)
    let isValidPassword = false
    let passwordChallenge = false
    let changePassword = false
    let nameEditable = false
    let emailEditable = false
    let dataUser = {}
    let waiting = false
    const updateUserData = async () => {
        waiting = true
        if (
            ['email', 'name', 'lastName']
                .filter((x) => dataUser[x] !== undefined)
                .some((x) => dataUser[x] !== $user[x])
        ) {
            let promise = user.update(dataUser).finally(() => {
                waiting = false
            })
            if(toast) toast.promise(promise, {
	            loading: 'Actualizando información...',
	            success: 'Datos actualizados!',
	            error: 'No se pudieron actualizar los datos.',
	        })
        }
    }
    const changeUserPassword = async (_) => {
        waiting = true
        if (dataUser.password) {
            await user.update(dataUser)
            changePassword = false
        }
        waiting = false
    }
    const toggleName = async (_) => {
        if (nameEditable) await updateUserData()
        nameEditable = !nameEditable
    }
    const toggleEmail = async (_) => {
        if (emailEditable) await updateUserData()
        emailEditable = !emailEditable
    }

    // Proceso de Modificacion
    let dataModification = null
    let showEditMod = false
    let showMod = false
    let fetching = false

    function setInputsAndSections(conf) {
        if (conf) {
            let inputs_modif = conf?.editable
                ? conf?.updateFields
                : conf.fields.map(({ key }) => key)
            let sections_modif = inputs_modif
                .map((x) => x.substr(-2))
                .concat(
                    conf.docs.some(
                        ({ state }) => state === 'Certificado Rechazado'
                    )
                        ? ['doc']
                        : []
                )
            console.log({ inputs_modif, sections_modif })
            return [inputs_modif, sections_modif]
        } else {
            return [[], []]
        }
    }

    $: [inputs_modif, sections_modif] = setInputsAndSections(dataModification)

    $: [_, badFields] = resolveFormfields(dataFetch)

    $: incompleteProviderData = badFields.length > 0

    // $: if(incompleteProviderData === true && sections_modif?.length === 0) {
    //   let tmpSections = [...badFields.reduce((ac, cu) => ac.add(dataFetch[cu] ? cu.substr(-2) : undefined), new Set())]
    //   // sections_modif = [tmpSections.includes('ii') ? 'doc' : undefined, ...tmpSections].filter(x => x)
    // }

    $: if ($user?.preloaded && incompleteProviderData) {
        window.localStorage.setItem('dataConfirmation', 'false')
        confirmationCompleted = false
    }
    $: console.log({ inputs_modif, sections_modif, badFields })
</script>

<Breadcrumb options={sites} />
<Banner
    title={$user?.fullName}
    label="usuario administrador"
    info={[
        { label: 'Correo electrónico', value: $user?.email },
        {
            label: 'Tipo y número de documento',
            value: `${$user?.docType} ${$user?.docNumber}`,
        },
        {
            label: 'En representación de',
            value: $user?.accounts[$user?.defaultAccount]['name'],
        },
    ]}
/>
<div
    in:fly={{ delay: 250, duration: 200 }}
    style="width: 100%; padding: 25px 68px 68px 68px"
>
    <Typography type="h4" style="margin: 0 0 11px 0"
        >Usuario administrador</Typography
    >
    <Typography type="body" style="margin: 2px 0 0 0" color="grey-800"
        >Seleccioná uno de los campos a continuación para editar tu información
        personal.</Typography
    >
    <div
        style="width: 100%; display: flex; flex-direction: row; padding: 40px 0; gap: 38px"
    >
        <div
            style={`
      background: #FFFFFF;
      display: flex;
      position: relative;
      border-radius: 8px;
      width: 380px;
      padding: 0 25px;
      height: auto;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 24px;
    `}
        >
            <Avatar size="medium" name={$user?.shortName || ''} />
            <span
                style="width: auto; min-width: 230px; background: #F6F6F6; display: flex; flex-direction: column; gap: 4px; box-sizing: border-box; padding: 8px; border-radius: 8px"
            >
                <Typography style="margin: 0; text-align: center" type="h4"
                    >{$user?.shortName || '-- --'}</Typography
                >
                <Typography
                    style="margin: 0; text-align: center"
                    color="grey-800"
                    type="subtitle">{$user?.email || '-'}</Typography
                >
            </span>
        </div>
        <Form quiet bind:data={dataUser}>
            <FormBoxContainer title="Información del usuario">
                <svelte:fragment slot="option">
                    <Button
                        size="small"
                        style="padding: 4px 8px; gap: 4px"
                        on:click={(_) => (changePassword = true)}
                    >
                        <LockClosedOutline color="#FFF" />
                        <Typography type="body" color="white"
                            >Cambiar contraseña</Typography
                        >
                    </Button>
                </svelte:fragment>
                <FormBoxRow>
                    {#if nameEditable}
                        <FormBoxCell label="Nombre/s">
                            <InputText name="name" quiet value={$user?.name} />
                        </FormBoxCell>
                        <FormBoxCell label="Apellido/s">
                            <InputText
                                name="lastName"
                                quiet
                                value={$user?.lastName}
                            />
                        </FormBoxCell>
                    {:else}
                        <FormBoxCell
                            label="Nombre y apellido"
                            value={$user?.fullName}
                        />
                    {/if}
                    <span
                        style="display: flex;  padding: 0 20px; cursor:pointer ; position: relative"
                        on:click={toggleName}
                    >
                        <svelte:component this={!nameEditable ? Edit : Tick} />
                    </span>
                </FormBoxRow>
                <FormBoxRow>
                    {#if emailEditable}
                        <FormBoxCell label="Correo electrónico">
                            <InputText
                                style="width: 100%"
                                quiet
                                name="email"
                                value={$user?.email}
                            />
                        </FormBoxCell>
                    {:else}
                        <FormBoxCell
                            label="Correo electrónico"
                            value={$user?.email}
                        />
                    {/if}
                    <span
                        style="display: flex;  padding: 0 20px; cursor:pointer ; position: relative"
                        on:click={toggleEmail}
                    >
                        <svelte:component this={!emailEditable ? Edit : Tick} />
                    </span>
                </FormBoxRow>
            </FormBoxContainer>
        </Form>
    </div>
    {#await request}
        <div style="display: flex; width: 100%; justify-content: center">
            <Spinner />
        </div>
    {:then { data }}
        <ModificacionProveedor
            bind:show={showEditMod}
            on:success={(e) => {
                sendData(e.detail.data)
            }}
            providerData={data}
            review={incompleteProviderData && sections_modif?.length === 0}
            renderSections={sections_modif}
            inputs={inputs_modif}
            restricted={!incompleteProviderData}
            comment={dataModification ? dataModification?.comment : null}
            bind:fetching
        />
        <ViewModificacion data={dataModification} bind:show={showMod} />
        {@const editable = editableForm}
        <Typography type="h4" style="margin: 0 0 11px 0">Información</Typography
        >
        <!-- <Typography type="body" style="margin: 2px 0 0 0" color="grey-800">A continuación puede solicitar una modificación.</Typography> -->
        {#if incompleteProviderData && !dataModification}
            <Alert type="error" style="margin: 25px 0 25px 0">
                <span
                    style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: 15px"
                >
                    <Typography style="margin: 0 auto; padding: 0" type="body"
                        ><strong>
                            Datos incompletos. Por favor complete el formulario.
                        </strong></Typography
                    >
                    <Button
                        on:click={(_) => (showEditMod = true)}
                        disabled={showEditMod}
                        label="Completar datos"
                    />
                </span>
            </Alert>
        {/if}
        {#if dataModification}
            <br />
            <WidgetModificacion
                config={dataModification}
                on:preview={(_) => (showMod = true)}
                on:update={(_) => (showEditMod = true)}
            />
        {/if}
        <ProviderDetail {data} />
        {#if !editable}
            <Alert type="warning" style="margin: 25px 0 25px 0">
                <span
                    style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: 15px"
                >
                    <Typography style="margin: 0 auto; padding: 0" type="body"
                        ><strong>
                            No se pueden realizar nuevas modifiaciones hasta que
                            se procese la solicitud anterior.
                        </strong></Typography
                    >
                </span>
            </Alert>
        {:else}
            <div class="buttonSet">
                {#if $user?.preloaded && (incompleteProviderData || !confirmaMigrado) && !confirmationCompleted}
                    {#if incompleteProviderData}
                        <Button
                            on:click={(_) => (showEditMod = true)}
                            label="Completar datos"
                        />
                    {:else if !confirmaMigrado}
                        <Button
                            on:click={(_) => {
                                showEditMod = true
                                window.localStorage.removeItem(
                                    'dataConfirmation'
                                )
                                confirmationCompleted = true
                            }}
                            type="primary"
                            label="Solicitar modificación"
                        />
                        <Button
                            on:click={(_) => {
                                addHistoryLog(
                                    `${$user.name} ${$user.lastName} - Aprobó los datos del proveedor migrado.`,
                                    (_) => (confirmaMigrado = true)
                                )
                                    .then((_) => {
                                        window.localStorage.removeItem(
                                            'dataConfirmation'
                                        )
                                        confirmationCompleted = true
                                    })
                                    .catch((_) => (confirmaMigrado = false))
                            }}
                            label="Confirmar datos"
                        />
                    {/if}
                {:else}
                    <Button
                        on:click={(_) => (showEditMod = true)}
                        type="primary"
                        label="Solicitar modificación"
                    />
                {/if}
            </div>
        {/if}
        {#if docNeeded.some((x) => x[1] == false) || ['Constancia de inscripción ARCA', 'Constancia de inscripción de Ingresos Brutos'].some((x) => !certificados.includes(x))}
            <Alert type="warning" style="margin: 25px 0 25px 0">
                <span
                    style="display: flex; flex-direction: row; justify-content: center; align-items: center; gap: 15px"
                >
                    <Typography style="margin: 0 auto; padding: 0" type="body"
                        ><strong>
                            Si desea puede actualizar su documentación.
                        </strong></Typography
                    >
                    <Button
                        on:click={(_) => {
                            navigate('/home/documents')
                        }}
                        style="background: #FF9F00"
                        label="Actualizar"
                    />
                </span>
            </Alert>
        {/if}
    {:catch _}
        Error al recuperar la información
    {/await}
</div>

<BackDrop
    style="padding-top: 70px;position: fixed; top: 0; z-index: var(--lvl-2);"
    bind:visible={changePassword}
>
    <Modal
        title="Cambiar contraseña"
        on:close={(_) => (changePassword = false)}
        on:clickout={(_) => (changePassword = false)}
        subtitle="Ingresá tus datos para solicitar el cambio de contraseña."
        scrolleable={false}
    >
        <!-- <Row> -->
        <InputPassword
            label="Nueva Contraseña"
            signUp
            bind:value={dataUser.password}
            bind:valid={passwordChallenge}
            validations={[
                {
                    helper: 'Debe tener al menos 8 caracteres',
                    func: (v) => v && v.length >= 8,
                },
                {
                    helper: 'Usa al menos un número o símbolo.',
                    func: (v) => v && v.match(/\d|\W|\s/),
                },
                {
                    helper: 'No debe contener tu nombre u apellido.',
                    func: (v) =>
                        v &&
                        !v.match(
                            new RegExp(`${$user?.name}|${$user?.lastName}`, 'i')
                        ),
                },
            ]}
            errorMsg="Password most be at the same."
        />
        <InputPassword
            label="Repita contraseña"
            bind:valid={isValidPassword}
            validation={(v) => v === dataUser.password}
            errorMsg="Las contraseñas deben coincidir"
        />
        <!-- </Row> -->
        <svelte:fragment slot="buttonSet">
            <span
                style="display: flex; ;width: 100%; flex-direction: row; justify-content: flex-end"
            >
                <Button
                    disabled={!(isValidPassword && passwordChallenge)}
                    on:click={changeUserPassword}
                    label="Cambiar contraseña"
                />
            </span>
        </svelte:fragment>
    </Modal>
</BackDrop>

<style>
    .buttonSet {
        display: flex;
        gap: 8px;
        justify-content: flex-end;
    }
</style>
